var _path, _g, _path2, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarUniSexe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12799_121543",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 82
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12799_121543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82Z",
    fill: "#F1F1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12799_121543",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 82
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12799_121543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9993 52.081C50.7911 52.081 58.729 44.1432 58.729 34.3513C58.729 24.5595 50.7911 16.6216 40.9993 16.6216C31.2074 16.6216 23.2695 24.5595 23.2695 34.3513C23.2695 44.1432 31.2074 52.081 40.9993 52.081Z",
    fill: "#9DA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2038 20.6133C54.6983 23.668 56.1954 27.5697 56.1954 31.8212C56.1954 41.6132 48.2577 49.5509 38.4657 49.5509C34.2143 49.5509 30.3125 48.0537 27.2578 45.5593C30.5095 49.5398 35.4553 52.0811 40.9959 52.0811C50.7879 52.0811 58.7256 44.1433 58.7256 34.3514C58.7256 28.8108 56.1844 23.865 52.2038 20.6133Z",
    fill: "#8792F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5057 49.4878C56.4453 49.5494 56.385 49.6121 56.3235 49.6737C54.335 51.6621 52.0178 53.2246 49.4372 54.3167C46.7629 55.447 43.925 56.0207 41.0008 56.0207C38.0766 56.0207 35.2386 55.447 32.5644 54.3167C29.9837 53.2246 27.6666 51.6634 25.6781 49.6737C25.6166 49.6121 25.5562 49.5494 25.4959 49.4878C18.0346 52.444 11.6211 57.4723 6.96094 63.86C14.3237 74.8007 26.8207 81.9997 41.0008 81.9997C55.1809 81.9997 67.6779 74.8007 75.0406 63.86C70.3804 57.4711 63.9669 52.444 56.5057 49.4878Z",
    fill: "#9DA7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12799_121543",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12799_121543)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M69.031 70.9203H69.0285C69.0285 70.9203 53.994 72.0924 46.545 70.9203L46.5413 70.9191L49.729 76.9422C34.6599 76.9102 21.7714 67.6046 16.4599 54.4304C12.8154 57.0492 9.60562 60.2357 6.96094 63.8617C14.3237 74.8011 26.8207 82.0002 41.0008 82.0002C51.8418 82.0002 61.7002 77.7918 69.031 70.9203Z",
    fill: "#F1F1FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUniSexe);
export default __webpack_public_path__ + "static/media/avatarUniSexe.292274c1f49ef5dba197630196f3dc69.svg";
export { ForwardRef as ReactComponent };